import React from 'react';

const Footer = () => {
    return (
        <div className="Footer">
            <div className="ui inverted vertical footer segment">
                <div className="ui center aligned container">
                    <h4 className="ui inverted header">&copy; 2021 Aditya Bisoi</h4>
                    <a href="https://github.com/adityabisoi/startup-incubator" target="_blank"><i className="github square icon big"></i></a>
                </div>
            </div>
        </div>
    )
}

export default Footer;